export const OWNERSHIP_CHECK_FAILED = 'ownershipCheckFailed';
export const MISMATCHED_RESPONSES = 'mismatchedResponses';
export const PRICING_AND_PURCHASING_FAILED_STATUS = 'pricingAndPurchasingFailedStatus';
export const COMMERCE_HUB_GATED = 'commerceHubGatedErrorPage';
export const PRICING_PURCHASING_FAILED = 'pricingAndPurchasingChecksFailed';
export const DEFAULT = 'default';